module.exports = __webpack_public_path__ + "static/media/servicoAutomotivo.445e1b43.jpg";